export enum MagentoVersion {
  Default = 'default',
  Ver24 = '2.4'
}
